<div class="main-layout">
  <app-side-menu class="layout-sidebar"></app-side-menu>
  
  <div class="layout-content">
    <header class="layout-header">
      <div class="header-content">
        <h1>Admin Portal</h1>

         <div class="user-info" *ngIf="authService.currentUser as user">
          <span>{{ user.displayName || user.email }}</span>
        
        <button class="profile-icon-button" (click)="navigateToProfile()">
            <span class="profile-icon">👤</span> <!-- You can use an image or an initial here too -->
          </button>
          </div>
      </div>
    </header>
    <main class="content-container">
      <router-outlet></router-outlet>
    </main>
 <footer class="layout-footer" style="text-align: center; padding: 10px; background-color: #f1f1f1;">
    <p style="margin: 0;"> Copyright &copy; 2025 DiGivCards.ai .</p>
    <p style="margin: 0;">All rights reserved. A Unit of Tamilarasi Technologies Private Limited.</p>
</footer>
  </div>
</div>
